// src/components/question/QuestionStats.tsx
// ✅ SEM AVISO DE "10 RESPOSTAS"

import React from 'react';
import { BarChart3 } from 'lucide-react';
import { QuestionStats as Stats } from '../../types/question.types';
import './QuestionStats.css';

interface QuestionStatsProps {
    stats: Stats | null;
    correctAlternative: 'A' | 'B' | 'C' | 'D' | 'E';
    userSelectedAlternative?: 'A' | 'B' | 'C' | 'D' | 'E' | null;
}

const QuestionStats: React.FC<QuestionStatsProps> = ({
    stats,
    correctAlternative,
    userSelectedAlternative
}) => {
    // ✅ SE NÃO TIVER STATS, NÃO RENDERIZA NADA (SEM AVISO)
    if (!stats || stats.totalAnswers === 0) {
        return null;
    }

    const alternatives: Array<'A' | 'B' | 'C' | 'D' | 'E'> = ['A', 'B', 'C', 'D', 'E'];

    return (
        <div className="question-stats">
            <div className="stats-header">
                <BarChart3 size={18} />
                <span>Distribuição de respostas ({stats.totalAnswers} usuários)</span>
            </div>

            <div className="stats-bars">
                {alternatives.map(letter => {
                    const percentage = stats.percentages[letter] || 0;
                    const isCorrect = letter === correctAlternative;
                    const isUserChoice = letter === userSelectedAlternative;

                    return (
                        <div
                            key={letter}
                            className={`stat-bar-container ${isCorrect ? 'correct' : ''} ${isUserChoice ? 'user-choice' : ''}`}
                        >
                            <div className="stat-bar-label">
                                <span className="stat-letter">{letter}</span>
                                <span className="stat-percentage">{percentage}%</span>
                            </div>
                            <div className="stat-bar-track">
                                <div
                                    className="stat-bar-fill"
                                    style={{ width: `${percentage}%` }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>

            {stats.realDifficulty !== null && (
                <div className="stats-difficulty">
                    <span className="difficulty-label">Taxa de acerto:</span>
                    <span className="difficulty-value">{stats.realDifficulty}%</span>
                </div>
            )}
        </div>
    );
};

export default QuestionStats;